import { render } from "./Repository.vue?vue&type=template&id=245a44a8&scoped=true&ts=true"
import script from "./Repository.vue?vue&type=script&lang=ts"
export * from "./Repository.vue?vue&type=script&lang=ts"

import "./Repository.vue?vue&type=style&index=0&id=245a44a8&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245a44a8"]])

export default __exports__